import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import AdditionalInfoAndroid from './../../../common/additionalInfo.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`This callback is trigger when the payment is not authorized as it’s an asynchronous alternative payment method, such as a voucher payment method.`}</p>
    <Callout emoji='⚠️' mdxType="Callout">
      <p>{`This method will be called only when using the `}<inlineCode parentName="p">{`PrimerPaymentHandling.AUTO`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "./../../../common/settings/primerSettings#properties"
        }}>{`flow`}</a>{`.`}</p>
    </Callout>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`fun onAdditionalInfoReceived(additionalInfo: PrimerCheckoutAdditionalInfo)
`}</code></pre>
    <h3>{`Parameters`}</h3>
    <Group mdxType="Group">
	<Item title='additionalInfo' subtitle='PrimerCheckoutAdditionalInfo' label='Required' mdxType="Item">
		<AdditionalInfoAndroid mdxType="AdditionalInfoAndroid" />
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      